export default [
    {
        name: 'matcapTexture',
        type: 'texture',
        path: 'textures/matcaps/3g.jpg'
    },
    {
        name: 'matcapTexture2',
        type: 'texture',
        path: 'textures/matcaps/1.jpg'
    },
    // ================== COMBO ================
    {
        name: 'combotexgrigio',
        comboName: 'Tessuto bianco',
        type: 'texture',
        path: 'textures/combo/combo1.jpg',
        colore1: 'texgrigia',
        colore2: 'vellgrigio'
    },
    {
        name: 'combotexverdebianco',
        comboName: 'Tessuto rosso',
        type: 'texture',
        path: 'textures/combo/combo2.jpg',
        colore1: 'texverdebianca',
        colore2: 'vellverde'
    },
    {
        name: 'combotexottanio',
        comboName: 'Tessuto rosso',
        type: 'texture',
        path: 'textures/combo/combo3.jpg',
        colore1: 'texottanio',
        colore2: 'texoro'
    },
    {
        name: 'combotexbeige',
        comboName: 'Tessuto rosso',
        type: 'texture',
        path: 'textures/combo/combo4.jpg',
        colore1: 'texbeigegrano',
        colore2: 'texmuschio'
    },
    {
        name: 'combotexbiancotrama',
        comboName: 'Tessuto Bianco con trama',
        type: 'texture',
        path: 'textures/combo/combo5.jpg',
        colore1: 'texbeige',
        colore2: 'texdiagonali'
    },
    {
        name: 'combotexcotonegrosso',
        comboName: 'Tessuto Bianco con trama',
        type: 'texture',
        path: 'textures/combo/combo6.jpg',
        colore1: 'texcotonegrosso',
        colore2: 'texpallini'
    },
    {
        name: 'combotexcotoneverde',
        comboName: 'Tessuto Bianco con trama',
        type: 'texture',
        path: 'textures/combo/combo7.jpg',
        colore1: 'texcotonegrosso2',
        colore2: 'texmuschiorosso'
    },
    {
        name: 'combotextramacolorata',
        comboName: 'Tessuto Bianco con trama',
        type: 'texture',
        path: 'textures/combo/combo8.jpg',
        colore1: 'texrame',
        colore2: 'textramacolorata'
    },
    {
        name: 'combotexblu',
        comboName: 'Tessuto Bianco con trama',
        type: 'texture',
        path: 'textures/combo/combo9.jpg',
        colore1: 'texarancio',
        colore2: 'texspezzata'
    },
    {
        name: 'combotexnera',
        comboName: 'Tessuto nero',
        type: 'texture',
        path: 'textures/combo/combo10.jpg',
        colore1: 'texnero',
        colore2: 'vellbianco'
    },
    {
        name: 'combopellenera',
        comboName: 'Pelle nera',
        type: 'texture',
        path: 'textures/combo/combo11.jpg',
        colore1: 'pellenera',
        colore2: 'pellebeige'
    },
    {
        name: 'combopellecuoio',
        comboName: 'Pelle cuoio',
        type: 'texture',
        path: 'textures/combo/combo12.jpg',
        colore1: 'cuoio',
        colore2: 'pellebeige'
    },
    {
        name: 'combopellebeige',
        comboName: 'Pelle beige',
        type: 'texture',
        path: 'textures/combo/combo13.jpg',
        colore1: 'pellebeige',
        colore2: 'texgeometria'
    },
    {
        name: 'combopellerossa',
        comboName: 'Pelle rossa',
        type: 'texture',
        path: 'textures/combo/combo14.jpg',
        colore1: 'pellerossa',
        colore2: 'vellnero'
    },

    
    // ================== TESSUTI ================
    {
        name: 'vellgrigio',
        colorName: 'Velluto Grigio',
        type: 'texture',
        path: 'textures/vellgrigio.webp',
        aointensity:0.8,
        lmintensity:1,
        roughness:3,
        invert:true,
        // rgb: new Array(1,1,1)
        // rgb: new Array(1.1,0.02,0.02)
        rgb: new Array(0.5,0.5,0.5)

    },
    {
        name: 'vellbianco',
        colorName: 'Velluto Bianco',
        type: 'texture',
        path: 'textures/vellgrigio.webp',
        aointensity:0.5,
        lmintensity:1,
        roughness:3,
        invert:true,
        // rgb: new Array(1,1,1)
        rgb: new Array(1.1,1.1,1.1)
        // rgb: new Array(-7,-0.01,-1)

    },
    {
        name: 'vellnero',
        colorName: 'Velluto Nero',
        type: 'texture',
        path: 'textures/vellgrigio.webp',
        aointensity:2,
        lmintensity:1,
        roughness:2,
        invert:true,
        // rgb: new Array(1,1,1)
        rgb: new Array(-0.01,-0.01,-0.01)
        // rgb: new Array(-7,-0.01,-1)

    },
    {
        name: 'vellverde',
        colorName: 'Velluto Verde',
        type: 'texture',
        path: 'textures/vellgrigio.webp',
        aointensity:0.9,
        lmintensity:1,
        roughness:3,
        invert:true,
        // rgb: new Array(1,1,1)
        // rgb: new Array(1.1,0.02,0.02)
        rgb: new Array(0.35,0.5,0.1)
        
    },
    {
        name: 'texgrigia',
        colorName: 'texgrigia',
        type: 'texture',
        path: 'textures/texgrigia.webp',
        aointensity:0.95,
        lmintensity:0,
        roughness:3,
        invert:false

    },
    {
        name: 'texverdebianca',
        colorName: 'Tessuto verdebianco',
        type: 'texture',
        path: 'textures/texverdebianca.webp',
        aointensity:0.95,
        lmintensity:0.95,
        roughness:3,
        invert:false

    },
    {
        name: 'texottanio',
        colorName: 'Tessuto ottanio',
        type: 'texture',
        path: 'textures/texottanio.webp',
        aointensity:1.1,
        lmintensity:0,
        roughness:2,
        invert:false,
        rgb: new Array(1,2,2)

    },
    {
        name: 'texoro',
        colorName: 'Tessuto beige',
        type: 'texture',
        path: 'textures/texneutra.webp',
        aointensity:0.92,
        lmintensity:0.9,
        roughness:3,
        invert:true,
        rgb: new Array(1.3,1,0.5)
    },
    {
        name: 'texbeige',
        colorName: 'Tessuto beige',
        type: 'texture',
        path: 'textures/texneutra.webp',
        aointensity:0.92,
        lmintensity:0.9,
        roughness:3,
        invert:false,
        rgb: new Array(0.95,0.65,0.5)
    },
    {
        name: 'texbeigegrano',
        colorName: 'Tessuto beige',
        type: 'texture',
        path: 'textures/texbeige.webp',
        aointensity:0.92,
        lmintensity:0.9,
        roughness:3,
        invert:false
        // rgb: new Array(0.55,0.5,0.3)
    },
    {
        name: 'texblu',
        colorName: 'Tessuto blu',
        type: 'texture',
        path: 'textures/texneutra.webp',
        aointensity:0.92,
        lmintensity:0.9,
        roughness:3,
        invert:false,
        rgb: new Array(0.2,0.2,0.8)
    },
    {
        name: 'texmuschio',
        colorName: 'Tessuto blu',
        type: 'texture',
        path: 'textures/texmuschio.webp',
        aointensity:0.95,
        lmintensity:11,
        roughness:3,
        invert:false,
        // rgb: new Array(0.0,0.2,0.5)
    },
    {
        name: 'texmuschiorosso',
        colorName: 'Tessuto blu',
        type: 'texture',
        path: 'textures/texmuschio.webp',
        aointensity:0.95,
        lmintensity:11,
        roughness:3,
        invert:false,
        rgb: new Array(1.2,0.6,0.08)
    },
    {
        name: 'texdiagonali',
        colorName: 'Tessuto fantasia diagonale',
        type: 'texture',
        path: 'textures/texdiagonali.webp',
        aointensity:0.95,
        lmintensity:0,
        roughness:3,
        invert:false,
        // rgb: new Array(0.0,0.2,0.5)
    },
    {
        name: 'texpallini',
        colorName: 'Tessuto fantasia a pallini',
        type: 'texture',
        path: 'textures/texpallini.webp',
        aointensity:0.90,
        lmintensity:2,
        roughness:3,
        invert:false
        // rgb: new Array(0.0,0.2,0.5)
    },
    {
        name: 'texcotonegrosso',
        colorName: 'Tessuto cotone grosso',
        type: 'texture',
        path: 'textures/texcotonegrosso.webp',
        aointensity:1.2,
        lmintensity:1,
        roughness:3,
        invert:false,
        rgb: new Array(0.05,0.1,0.25)
    },
    {
        name: 'texcotonegrosso2',
        colorName: 'Tessuto cotone grosso',
        type: 'texture',
        path: 'textures/texcotonegrosso.webp',
        aointensity:1.02,
        lmintensity:1,
        roughness:3,
        invert:false,
        rgb: new Array(0.02,0.1,0.08)
    },
    {
        name: 'textramacolorata',
        colorName: 'Tessuto cotone grosso',
        type: 'texture',
        path: 'textures/tramacolorata.webp',
        aointensity:0.99,
        lmintensity:1,
        roughness:2,
        invert:false
        // rgb: new Array(0.0,0.2,0.5)
    },
    {
        name: 'texrame',
        colorName: 'Tessuto cotone grosso',
        type: 'texture',
        path: 'textures/texrame.webp',
        aointensity:1.05,
        lmintensity:2,
        roughness:2,
        invert:false,
        rgb: new Array(0.4,0.1,0.1)
    },
    {
        name: 'texarancio',
        colorName: 'Tessuto cotone grosso',
        type: 'texture',
        path: 'textures/texrame.webp',
        aointensity:1.05,
        lmintensity:2,
        roughness:2,
        invert:false,
        rgb: new Array(1.2,1.2,0.4)
    },
    {
        name: 'textramaaraba',
        colorName: 'Tessuto cotone grosso',
        type: 'texture',
        path: 'textures/texaraba.webp',
        aointensity:1.05,
        lmintensity:2,
        roughness:2,
        invert:false,
        rgb: new Array(0.6,0.6,0.5)
    },
    {
        name: 'texspezzata',
        colorName: 'Tessuto cotone grosso',
        type: 'texture',
        path: 'textures/texspezzata2.webp',
        aointensity:1.05,
        lmintensity:2,
        roughness:2,
        invert:false,
        rgb: new Array(1.5,1.1,1)
    },
    {
        name: 'texgeometria',
        colorName: 'Tessuto geometria',
        type: 'texture',
        path: 'textures/texgeometria.webp',
        aointensity:0.9,
        lmintensity:1,
        roughness:2,
        invert:false,
        // rgb: new Array(0.5,0.5,0.6)
    },
    //================ PELLE E CUOIO =============
    {
        name: 'pellenera',
        colorName: 'Pelle nera',
        type: 'texture',
        path: 'textures/pellenera.webp',
        aointensity:0.95,
        lmintensity:0,
        roughness:1,
        invert:false


    },
    {
        name: 'cuoio',
        colorName: 'Pelle color cuoio',
        type: 'texture',
        path: 'textures/cuoio.webp',
        aointensity:1.2,
        lmintensity:0,
        roughness:1.2,
        invert:false


    },
    {
        name: 'pellebeige',
        colorName: 'Pelle beige',
        type: 'texture',
        path: 'textures/pellebeige.webp',
        aointensity:0.9,
        lmintensity:0,
        roughness:1,
        invert:false

    },
    {
        name: 'pellerossa',
        colorName: 'Pelle rossa',
        type: 'texture',
        path: 'textures/pellerossa.webp',
        aointensity:0.9,
        lmintensity:0,
        roughness:1,
        invert:false

    },
    {
        name: 'texnero',
        colorName: 'tessuto nero',
        type: 'texture',
        path: 'textures/texnero.webp',
        aointensity:0.9,
        lmintensity:0,
        roughness:3,
        invert:false

    },


]